import { call, put, select } from 'redux-saga/effects';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { openBlankWindow, setWindowLocation } from '../../app/sagas/spaces/SpacesSagaHelpers';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { Messages } from '../../codegen/Localize';
import { FlowDetailInfo } from '../../ts/models/FlowInfo';
import { ContentDraftStatus } from '../../ts/ServerApi/types/ContentDraft';
import { EditFlowReduxAction } from '../actions/EditFlowReduxAction';
import { getFlowDetailInfo } from '../FlowsSagaHelpers';

export function* handleEditFlow(action: EditFlowReduxAction) {
  let newWindow: Window = null;
  try {
    const flow = action.flow;
    const urls: SpacesSiteUrls = yield select(siteUrlsSelector);
    newWindow = openBlankWindow();
    if (flow.draftStatus === ContentDraftStatus.unpublished) {
      setWindowLocation(newWindow, urls.flowEditorDraftUrl(flow.draftLuid));
    } else {
      const flowDetailInfo: FlowDetailInfo = yield call(getFlowDetailInfo, flow.id);
      const flowLuid = flowDetailInfo.luid;
      setWindowLocation(newWindow, urls.flowEditorFlowPath({flowLuid}));
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
